/* -------------------------------------------------------------------------------------
Router main page defining the different routes and if authentication is required

What to do to add new components:
* Add new route to routes array
* Create new vue in directory views
* Add new button in components/NavBar.vue

ACTION: implement automated inclusion of components (from vue mastery training)
---------------------------------------------------------------------------------------*/

//  vue imports
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'view-map',
    component: () => import('@/views/Map.vue'),
    alias: '/Map'
  },
  {
    path: '/about',
    name: 'view-about',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/dashboard',
    name: 'view-dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { requiresAuth: true } // indicates that this page is only available when user is authenticated
  },
  {
    path: '/login',
    name: 'view-login',
    component: () => import('@/views/LoginUser.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterUser.vue')
  },
  {
    path: '/user',
    name: 'view-user',
    component: () => import('@/views/UserUi.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Ensures that target route is only displayed when user is logged in. Else the root is displayed
router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user') // get the user item from the local store

  // checks if target route matches one of our routes (record) where the meta tag includes requiresAuth = true && user is not logged in
  if (to.matched.some(record => record.meta.requiresAuth && !loggedIn)) {
    next('/')
  } else {
    next()
  }
})

export default router
